import $ from 'jquery';

export default () => {
  Drupal.behaviors.processes_filter_select = {
    attach: function(context, settings) {
      const $form = $('#views-exposed-form-search-page-document-centre');

      $form.find('select[name="dspace_doc_type"]').once('select2-document-type').select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
      });
    }
  };
}
